import React from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getSeoConfig } from './routeRegistry';
import { toJsonLd } from './jsonLd';

// Config centralizado por ruta (desde route registry)
export const seoConfig = getSeoConfig();



const DEFAULT = seoConfig['/'];

// Componente que aplica SEO según la ruta (debe usarse DENTRO del Router)
export function DynamicSeo() {
  const location = useLocation();
  const pathname = location.pathname;
  
  // Buscar config exacta o usar default
  const config = seoConfig[pathname] || DEFAULT;
  const image = 'https://www.bluecmr.com/bluecmr.jpeg';
  
  return (
    <Helmet>
      <title>{config.title}</title>
      <meta name="description" content={config.description} />
      <link rel="canonical" href={config.canonical} />
      {config.alternates && Object.entries(config.alternates).map(([lang, url]) => (
        <link key={lang} rel="alternate" hrefLang={lang} href={url} />
      ))}
      <meta name="keywords" content={config.keywords} />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:type" content={config.type} />
      <meta property="og:title" content={config.title} />
      <meta property="og:description" content={config.description} />
      <meta property="og:url" content={config.canonical} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={config.title} />
      <meta name="twitter:description" content={config.description} />
      <meta name="twitter:image" content={image} />

      {/* Schema solo en home */}
      {pathname === '/' && (
        <script type="application/ld+json">
          {toJsonLd({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            url: 'https://www.bluecmr.com',
            name: 'BlueCMR',
            inLanguage: 'es-ES',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.bluecmr.com/buscar?q={search_term_string}',
              'query-input': 'required name=search_term_string'
            }
          })}
        </script>
      )}
    </Helmet>
  );
}

export function SeoProvider({ children }) {
  return <HelmetProvider>{children}</HelmetProvider>;
}
